// NOTES:
// Term is before first active term: No tab, no date.
// Term has no planned courses: No tab, no date.
// Today is before registration start date: Show reg start date and "Pick Times" tab/button.
// Today is between registration start & end dates, inclusive: Show reg start date and "Ready to Register" tab/button.
// Today is after registration end date: Show reg start date and "My Schedule" tab/button.
import * as _4 from 'lodash4';
import { APPlannedCourse } from '../../../global/builders/ap_planned_course_builder';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { APTermServant } from '../../../global/servants/ap_term_servant';
import { HiComponentAttributeChangedEvent } from './../../../global/types/common_types';
export class MyPlannerTermBoxButton {
  public term: any;
  public isPast: boolean;
  public credits: string;
  public buttonLabel: string;
  public buttonTitle: string;
  public coursesMissingRequisites: string[];
  public showconflictReminder: boolean = false;
  public showNoSectionAvailablePopup: boolean = false;
  private courseOfferedProblem: APPlannedCourse[] = [];

  constructor(
    public $scope: ng.IScope,
    public $state: ng.ui.IStateService,
    public $modal: any,
    public appConfigModel: any,
    public ngAPUserModeConfig: APUserModeConfig
  ) {}
  initialize() {
    this.showNoSectionAvailablePopup = false;
    const termStatus = this.term._termStatus.value || this.term._termStatus;
    this.buttonLabel = termStatus.button_label || 'Pick Times';
    this.buttonTitle = !APTermServant.isRegistrationButtonDisabled(this.term)
      ? termStatus.button_title || 'Times are available'
      : termStatus.button_title || 'Times not yet available';
  }
  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
  }

  showRegButton() {
    return (
      !APTermServant.isCompleted(this.term) &&
      !this.isPast &&
      !!this.term._genericSlots.length &&
      !this.ngAPUserModeConfig.isAdvisor() &&
      this.appConfigModel.isFeatureEnabled('reg-scheduler')
    );
  }

  goTo() {
    const noSectionsAvailable = this.term._disablePickTimes;
    if (noSectionsAvailable) {
      this.showNoSectionAvailablePopup = true;
      return;
    }

    this.coursesMissingRequisites = APTermServant.coursesMissingRequisites(this.term);
    if (this.term._plannedCourses) {
      this.courseOfferedProblem = this.term._plannedCourses.filter(
        (course: APPlannedCourse) => course.is_course_offered === false
      );
    }

    if (
      (this.appConfigModel.isFeatureEnabled('reg-requisite_reminder') && this.coursesMissingRequisites.length > 0) ||
      this.courseOfferedProblem.length > 0
    ) {
      this.showconflictReminder = true;
    } else {
      this.continue();
    }
  }

  showNoSectionAvailableOpenedChanged($event: HiComponentAttributeChangedEvent) {
    this.showNoSectionAvailablePopup = $event.detail.value;
  }

  hide() {
    this.showconflictReminder = false;
  }
  continue() {
    this.hide();
    this.$state.go(
      'my.schedule.registration',
      {
        termId: this.term.id
      },
      { reload: true }
    );
  }
}

class MyPlannerTermBoxButtonComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      term: '<',
      isPast: '<?',
      credits: '@'
    };
    this.controller = MyPlannerTermBoxButton;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/term_box_button/term_box_button.html';
  }
}
angular
  .module('capability-ng-academic-planner')
  .component('eabMyPlannerTermBoxButton', new MyPlannerTermBoxButtonComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_box_button/term_box_button.ts